import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-test-id"]

import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import Notification from '../Notification/Notification.vue';
import { useAccountStore, usePageStore } from '@/store';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BannerNotifications',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const outerClass = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);

/**
 * Filter notification by relevant products
 */
const accountStore = useAccountStore();
const filteredNotifications = computed(() => {
  return (props.fields.Notifications as Item[])?.filter((notification) => {
    if (
      /** Show if is for insurance AND member has insurance */
      (notification.fields?.forInsurance?.value &&
        accountStore.identityDetails?.portfolio?.insurancePolicies?.length) ||
      /** OR Show if is for roadside and member has roadside */
      (notification.fields?.forRoadside?.value &&
        accountStore.identityDetails?.portfolio?.assistanceProducts?.length) ||
      /** OR Show if is for bank and member has bank */
      (notification.fields?.forBank?.value && accountStore.identityDetails?.portfolio?.bankingProducts?.length)
    ) {
      return true;
    }

    // also show if none checked
    return (
      !notification.fields?.forBank?.value &&
      !notification.fields?.forRoadside?.value &&
      !notification.fields?.forInsurance?.value
    );
  });
});

return (_ctx: any,_cache: any) => {
  return (filteredNotifications.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['flex flex-col gap-3', _unref(outerClass)]),
        style: _normalizeStyle(_unref(inlineStyle)),
        "data-test-id": _unref(dataTestId)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNotifications.value, (notification, index) => {
          return (_openBlock(), _createBlock(Notification, {
            key: index,
            type: notification.fields?.type?.value,
            title: notification?.fields?.title?.value,
            description: notification?.fields?.content?.value,
            fullWidth: true,
            openByDefault: notification?.fields?.openByDefault?.value
          }, null, 8, ["type", "title", "description", "openByDefault"]))
        }), 128))
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})